class CartTool extends HTMLElement {
  constructor() {
    super();
    const buttons = this.querySelectorAll('.cartTool-item');
    buttons.forEach((button) => {
      button.addEventListener('click',(event) => {
        const id = event.target.dataset.popup;
        document.getElementById(id).classList.add('show');
        document.querySelector('.previewCart').classList.add('active-tool');
      })
    })
  }
}

customElements.define('cart-item-tool', CartTool);

class CartCancel extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('button').addEventListener('click',(event) => {
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-cancel-popup', CartCancel);

class CartNote extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('[data-update-note]').addEventListener('click', (event) => {
      this.val = this.querySelector('.text-area').value;
      const body = JSON.stringify({ note: this.val });
      fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-note', CartNote);

class CouponCode extends HTMLElement {
  constructor() {
    super();
    if (localStorage.getItem('storedDiscount')){
      this.querySelector('input[name="discount"]').value = localStorage.getItem('storedDiscount');  
    }
    this.querySelector('[data-update-coupon]').addEventListener('click', (event) => {
      this.val = this.querySelector('input[name="discount"]').value;
      localStorage.setItem('storedDiscount', this.val);
      fetch(`/discount/${this.val}`)
          .then((response) => response.text())
          .then((responseText) => {
        	
      });
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('coupon-code', CouponCode);

// Handle subscription dropdown in cart
document.addEventListener('DOMContentLoaded', () => {
  initSubscriptionSelectors();
  initSubscriptionUpgradeButtons();
  
  // Re-initialize after cart updates
  document.addEventListener('cart-update', () => {
    setTimeout(() => {
      initSubscriptionSelectors();
      initSubscriptionUpgradeButtons();
    }, 100);
  });
});

function initSubscriptionSelectors() {
  document.querySelectorAll('.rebuy-cart__flyout-item-subscription [data-subscription-select]').forEach(select => {
    // Remove existing listeners to prevent duplicates
    const newSelect = select.cloneNode(true);
    select.parentNode.replaceChild(newSelect, select);
    
    // Handle select change
    newSelect.addEventListener('change', async function(event) {
      const selectedValue = event.target.value;
      const selectorContainer = event.target.closest('.rebuy-cart__flyout-item-subscription');
      const itemKey = selectorContainer.dataset.cartItemKey;
      
      // Update optgroup label with selected plan's discount
      const selectedOption = event.target.options[event.target.selectedIndex];
      const discount = selectedOption.dataset.discount || '0';
      const optgroup = event.target.querySelector('optgroup');
      if (optgroup && discount) {
        optgroup.label = `Subscribe and Save ${discount}%`;
      }
      
      // Show loading state
      selectorContainer.classList.add('updating');
      event.target.disabled = true;

      try {
        // To update selling plan, we need to remove and re-add the item
        // First, get current item details
        const cartResponse = await fetch('/cart.js');
        if (!cartResponse.ok) throw new Error('Cart fetch failed: ' + cartResponse.status);
        const cart = await cartResponse.json();
        const currentItem = cart.items.find(item => item.key === itemKey);
        
        if (!currentItem) {
          throw new Error('Item not found in cart');
        }

        // Remove the item
        const changeUrl = (window.routes && window.routes.cart_change_url) ? window.routes.cart_change_url : '/cart/change.js';
        await fetch(changeUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: itemKey,
            quantity: 0
          })
        });

        // Re-add with selling plan (always subscription, no one-time option)
        const addBody = {
          id: currentItem.variant_id,
          quantity: currentItem.quantity,
          selling_plan: selectedValue
        };

        const addUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add.js';
        const addResponse = await fetch(addUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(addBody)
        });

        if (!addResponse.ok) {
          const errorData = await addResponse.json();
          throw new Error(errorData.description || 'Failed to update subscription');
        }

        // Get full cart to refresh (don't need addResponse.json() separately)
        const fullCartResponse = await fetch('/cart.js');
        if (!fullCartResponse.ok) throw new Error('Cart fetch failed: ' + fullCartResponse.status);
        const fullCart = await fullCartResponse.json();

        // Refresh cart sidebar
        if (typeof updateSideCartOptimized === 'function') {
          await updateSideCartOptimized(fullCart);
        } else if (typeof Shopify !== 'undefined' && Shopify.getCart) {
          Shopify.getCart((cart) => {
            if (typeof halo !== 'undefined' && halo.updateSidebarCart) {
              halo.updateSidebarCart(cart);
            }
          });
        }

        // Dispatch cart update event
        document.dispatchEvent(new CustomEvent('cart-update', { detail: fullCart }));
        
      } catch (error) {
        console.error('Error updating subscription:', error);
        // Revert select state on error
        const previousValue = event.target.dataset.currentPlan || '';
        event.target.value = previousValue;
        alert(error.message || 'Failed to update subscription. Please try again.');
      } finally {
        // Update current plan reference
        event.target.dataset.currentPlan = event.target.value;
        selectorContainer.classList.remove('updating');
        event.target.disabled = false;
      }
    });
  });
}

function initSubscriptionUpgradeButtons() {
  document.querySelectorAll('[data-subscription-upgrade]').forEach(button => {
    // Remove existing listeners to prevent duplicates
    const newButton = button.cloneNode(true);
    button.parentNode.replaceChild(newButton, button);
    
    newButton.addEventListener('click', async function(event) {
      event.preventDefault();
      event.stopPropagation();
      const upgradeContainer = event.target.closest('.cart-item-subscription-upgrade');
      const itemKey = upgradeContainer.dataset.cartItemKey;
      const sellingPlanId = upgradeContainer.dataset.sellingPlanId;
      const variantId = parseInt(upgradeContainer.dataset.variantId);
      
      // Show loading state
      upgradeContainer.classList.add('updating');
      event.target.disabled = true;
      
      // Ensure cart sidebar is scrollable
      const cartSidebar = document.querySelector('#halo-cart-sidebar');
      const cartWrapper = document.querySelector('#halo-cart-sidebar .previewCart-wrapper');
      if (cartSidebar) {
        cartSidebar.style.overflowY = 'auto';
        cartSidebar.style.overflowX = 'hidden';
      }
      if (cartWrapper) {
        cartWrapper.style.overflowY = 'auto';
        cartWrapper.style.overflowX = 'hidden';
      }

      try {
        // Get current item details
        const cartResponse = await fetch('/cart.js');
        if (!cartResponse.ok) throw new Error('Cart fetch failed: ' + cartResponse.status);
        const cart = await cartResponse.json();
        const currentItem = cart.items.find(item => item.key === itemKey);
        
        if (!currentItem) {
          throw new Error('Item not found in cart');
        }

        // Remove the item
        const changeUrl = (window.routes && window.routes.cart_change_url) ? window.routes.cart_change_url : '/cart/change.js';
        await fetch(changeUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: itemKey,
            quantity: 0
          })
        });

        // Re-add with selling plan
        const addBody = {
          id: variantId,
          quantity: currentItem.quantity,
          selling_plan: sellingPlanId
        };

        const addUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add.js';
        const addResponse = await fetch(addUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(addBody)
        });

        if (!addResponse.ok) {
          const errorData = await addResponse.json();
          throw new Error(errorData.description || 'Failed to upgrade to subscription');
        }

        // Get full cart to refresh (don't need addResponse.json() separately)
        const fullCartResponse = await fetch('/cart.js');
        if (!fullCartResponse.ok) throw new Error('Cart fetch failed: ' + fullCartResponse.status);
        const fullCart = await fullCartResponse.json();

        // Preserve footer section before update
        const cartWrapper = document.querySelector('#halo-cart-sidebar .previewCart-wrapper');
        const existingFooter = cartWrapper ? cartWrapper.querySelector('.previewCartInfo') : null;
        let footerHTML = null;
        if (existingFooter) {
          footerHTML = existingFooter.outerHTML;
        }

        // Refresh cart sidebar
        if (typeof updateSideCartOptimized === 'function') {
          await updateSideCartOptimized(fullCart);
        } else if (typeof Shopify !== 'undefined' && Shopify.getCart) {
          Shopify.getCart((cart) => {
            if (typeof halo !== 'undefined' && halo.updateSidebarCart) {
              halo.updateSidebarCart(cart);
            }
          });
        }

        // Dispatch cart update event
        document.dispatchEvent(new CustomEvent('cart-update', { detail: fullCart }));
        
        // Ensure footer (previewCartInfo) is visible and restored after update
        setTimeout(() => {
          const cartSidebar = document.querySelector('#halo-cart-sidebar');
          const updatedCartWrapper = document.querySelector('#halo-cart-sidebar .previewCart-wrapper');
          const previewCart = updatedCartWrapper ? updatedCartWrapper.querySelector('.previewCart') : null;
          
          // Ensure cart sidebar is scrollable
          if (cartSidebar) {
            cartSidebar.style.overflowY = 'auto';
            cartSidebar.style.overflowX = 'hidden';
          }
          if (updatedCartWrapper) {
            updatedCartWrapper.style.overflowY = 'auto';
            updatedCartWrapper.style.overflowX = 'hidden';
          }
          
          // Check if footer exists, if not restore it
          let previewCartInfo = updatedCartWrapper ? updatedCartWrapper.querySelector('.previewCartInfo') : null;
          
          if (!previewCartInfo && footerHTML && previewCart) {
            // Footer was removed, restore it
            previewCart.insertAdjacentHTML('afterend', footerHTML);
            previewCartInfo = updatedCartWrapper.querySelector('.previewCartInfo');
          }
          
          // Ensure footer section is visible - check multiple possible locations
          const allPreviewCartInfo = document.querySelectorAll('#halo-cart-sidebar .previewCartInfo, .halo-cart-sidebar .previewCartInfo, .previewCart-wrapper .previewCartInfo');
          allPreviewCartInfo.forEach(element => {
            element.style.display = 'block';
            element.style.visibility = 'visible';
            element.style.opacity = '1';
          });
          
          const allPreviewCartAction = document.querySelectorAll('#halo-cart-sidebar .previewCartAction, .halo-cart-sidebar .previewCartAction, .previewCart-wrapper .previewCartAction');
          allPreviewCartAction.forEach(element => {
            element.style.display = 'block';
            element.style.visibility = 'visible';
            element.style.opacity = '1';
          });
          
          const allButtonCheckout = document.querySelectorAll('#halo-cart-sidebar .button-checkout, .halo-cart-sidebar .button-checkout, .previewCart-wrapper .button-checkout');
          allButtonCheckout.forEach(element => {
            element.style.display = 'block';
            element.style.visibility = 'visible';
            element.style.opacity = '1';
          });
          
          // Re-initialize subscription selectors after cart update
          initSubscriptionSelectors();
          initSubscriptionUpgradeButtons();
        }, 300);
        
      } catch (error) {
        console.error('Error upgrading to subscription:', error);
        alert(error.message || 'Failed to upgrade to subscription. Please try again.');
      } finally {
        upgradeContainer.classList.remove('updating');
        event.target.disabled = false;
        
        // Re-enable scrolling
        const cartSidebar = document.querySelector('#halo-cart-sidebar');
        const cartWrapper = document.querySelector('#halo-cart-sidebar .previewCart-wrapper');
        if (cartSidebar) {
          cartSidebar.style.overflowY = 'auto';
          cartSidebar.style.overflowX = 'hidden';
        }
        if (cartWrapper) {
          cartWrapper.style.overflowY = 'auto';
          cartWrapper.style.overflowX = 'hidden';
        }
      }
    });
  });
}